import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({ standalone: false, 
  selector: 'app-modal',
  templateUrl: 'modal.component.html'
})
export class ModalComponent {
  @Input() ownerFname: string;
  @Input() ownerLname: string;
  @Input() ownerEmail: string;
  @Input() ownerUname: string;
  @Input() ownerAffiliation: string;

  public visible = false;
  public visibleAnimate = false;
  public defaultTimeout: number = 200;
  list: Object;

  constructor(public http: HttpClient,
              public router: Router) {
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => this.visibleAnimate = true, this.defaultTimeout);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => this.visible = false, this.defaultTimeout);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('userDetail')) {
      this.hide();
    }
  }

}
